import type { ChainId } from "../api/types";

type Props = { chain: ChainId; className?: string };

const LABELS: Record<ChainId, { short: string; color: string }> = {
  solana: { short: "SOL", color: "border-accent text-accent" },
  base: { short: "BASE", color: "border-ok text-ok" },
  ethereum: { short: "ETH", color: "border-purple-400 text-purple-400" },
  robinhood: { short: "RH", color: "border-cyan-400 text-cyan-400" },
  bnb: { short: "BNB", color: "border-yellow-400 text-yellow-500" },
  ink: { short: "INK", color: "border-fuchsia-400 text-fuchsia-400" },
  arc: { short: "ARC", color: "border-blue-400 text-blue-400" },
};

export function ChainBadge({ chain, className = "" }: Props): JSX.Element {
  const cfg = LABELS[chain];
  return (
    <span
      className={`inline-block px-1.5 py-0.5 text-[9px] uppercase tracking-nav border ${cfg.color} ${className}`}
    >
      {cfg.short}
    </span>
  );
}
